export default __webpack_public_path__ + "static/media/image10.40022d9b.svg";